// src/emitter.ts
function createPlatformEventEmitter() {
  const listeners = /* @__PURE__ */ new Map();
  return {
    on(event, handler) {
      let set = listeners.get(event);
      if (!set) {
        set = /* @__PURE__ */ new Set();
        listeners.set(event, set);
      }
      set.add(handler);
      return () => {
        listeners.get(event)?.delete(handler);
      };
    },
    off(event, handler) {
      listeners.get(event)?.delete(handler);
    },
    emit(event, payload) {
      const handlers = listeners.get(event);
      if (!handlers || handlers.size === 0) return;
      for (const handler of [...handlers]) {
        try {
          handler(payload);
        } catch (error) {
          console.error(`[events] listener for "${String(event)}" threw`, error);
        }
      }
    },
    clear() {
      listeners.clear();
    }
  };
}
var platformEvents = createPlatformEventEmitter();

export { createPlatformEventEmitter, platformEvents };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map